import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "../utils/page-title";

export const Route = createFileRoute("/centers")({
  head: () =>
    pageHead("Your Design Centers", {
      canonicalPath: "/centers",
    }),
});
